import React, { useState, useEffect, useContext } from 'react';
import './ticket.scss';
import Sidebar from '../../components/sidebar/Sidebar';
import Navbar from '../../components/navbar/Navbar';
import { useNavigate, Link } from 'react-router-dom';
import { doc, setDoc, serverTimestamp, addDoc, collection } from 'firebase/firestore';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { db, auth, storage } from '../../firebase';
import { ref, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
import { UserContext } from '../../Contexts/UserContext';

const Tickets = ({ inputs, title }) => {
    const { loggedUser, userData } = useContext(UserContext)
    const [file, setFile] = useState('');
    const [selectedUser, setSelectedUser] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [ticketData, setTicketData] = useState({
        subject: "",
        reporter: loggedUser.fullname,
        status: "Open",
        textarea: "",
        assignee: {},
    });
    const [percent, setPercent] = useState(null);
    const navigate = useNavigate();

    // useEffect(() => {
    //     const uploadFile = () => {
    //         const name = new Date().getTime() + file.name;
    //         const storageRef = ref(storage, file.name);

    //         const uploadTask = uploadBytesResumable(storageRef, file);

    //         uploadTask.on(
    //             'state_changed',
    //             (snapshot) => {
    //                 const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    //                 console.log('Upload is ' + progress + '% done');
    //                 setPercent(progress);
    //                 switch (snapshot.state) {
    //                     case 'paused':
    //                         console.log('Upload is paused');
    //                         break;
    //                     case 'running':
    //                         console.log('Upload is running');
    //                         break;
    //                     default:
    //                         break;
    //                 }
    //             },
    //             (error) => {
    //                 console.log(error);
    //             },
    //             () => {
    //                 getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
    //                     setData((prev) => ({ ...prev, img: downloadURL }));
    //                 });
    //                 // navigate(-1);
    //             }
    //         );
    //     };
    //     file && uploadFile();
    // }, [file]);

    const handleInput = (e) => {
        const { id, value } = e.target;
        if (id === 'assignee') {
            setSelectedUser(value);
        } else {
            setTicketData({ ...ticketData, [id]: value });
        }
    };

    const handleAddTicket = async (e) => {
        e.preventDefault();

        try {
            // Add a new document with a generated id.
            await addDoc(collection(db, 'invoices'), {
                ...ticketData,
                assignee: searchQuery,
                timeStamp: serverTimestamp(),
            });
            navigate(-1);
        } catch (err) {
            console.log(err);
        }
    };
    const handleClose = () => {
        navigate(-1);
    };

    return (
        <div className="container">
            <Sidebar />
            <div className="invoiceContainer">
                <Navbar />
                <div className="description">
                    <div>
                        <h1>{title}</h1>
                    </div>
                    <form onSubmit={handleAddTicket}>
                        <div className="formInput">
                            <h3 className="h3title" htmlFor="file">Upload Image or File</h3>
                            <input type="file" id="file" style={{ border: 'none' }} />
                        </div>
                        {inputs.map((input) => (
                            <div className="formInput" key={input.id}>
                                <h3 className="h3title">{input.label}:</h3>
                                {input.type === "select" ? (
                                    <select
                                        id={input.id}
                                        value={ticketData.status}
                                        onChange={handleInput}
                                        required
                                    >
                                        {input.options.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <input
                                        id={input.id}
                                        onChange={handleInput}
                                        type={input.type}
                                        placeholder={input.placeholder}
                                        required
                                    />
                                )}
                            </div>
                        ))}
                        <div className="formInput">
                            <h3 className="h3title">Assignee:</h3>
                            <input
                                id="assignee"
                                type="text"
                                value={searchQuery}
                                onChange={(e) => {
                                    setSearchQuery(e.target.value)
                                }}
                                placeholder="Search by name..."
                            />
                            <div>
                                {searchQuery && (
                                    <ul>
                                        {userData &&
                                            userData
                                                .filter(
                                                    (user) =>
                                                        user.fullname &&
                                                        user.fullname.toLowerCase().includes(searchQuery.toLowerCase())
                                                )
                                                .map((user) => (
                                                    <li
                                                        onClick={() => {
                                                            setSelectedUser(user);
                                                            setSearchQuery(user.fullname);
                                                        }}
                                                        key={user.id}
                                                    >
                                                        {user.fullname}
                                                    </li>
                                                ))}
                                    </ul>
                                )}

                            </div>

                        </div>
                        <div className="formInput">
                            <h3 className="h3title">Add Description:</h3>
                            <textarea id="textarea" type="text" placeholder="enter text here..." onChange={handleInput}></textarea>
                        </div>
                        <div className="buttons">
                            <button className="greenButton" type="submit">Post</button>
                            <button className="redButton" onClick={handleClose}>Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Tickets;